export default __webpack_public_path__ + "static/media/i012vp.70597ed2.webp";